import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../app/store";

export interface invoiceDetailState {
  data: [] | null | any;
  totalPage: number | null;
  currentPage: number | null;
  totalRecords: number | null;
}

const initialState: invoiceDetailState = {
  data: null,
  totalPage: null,
  currentPage: null,
  totalRecords: null,
};

export const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {
    setInvoiceDetail: (state, action) => {
      state.data = action.payload.data;
      state.totalPage = action.payload.totalPage;
      state.currentPage = action.payload.currentPage;
      state.totalRecords = action.payload.totalRecords;
    },
    addInvoiceDetail: (state: any, action) => {
      state.data = action.payload;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const { setInvoiceDetail, addInvoiceDetail, reset } =
  invoiceSlice.actions;
export const getInvoiceDetails = (state: RootState) => state.invoice.data;
export const getInvoiceTotalRecord = (state: RootState) =>
  state.invoice.totalRecords;
export const getInvoiceTotalPage = (state: RootState) =>
  state.invoice.totalPage;
  export const getInvoiceCurrentPage = (state: RootState) =>
  state.invoice.currentPage;

export default invoiceSlice.reducer;
